import CrudCustom from '../../../libs/custom/CrudCustom';

let TransaksiPosService = new CrudCustom('/transaksi-penjualan-pos');
export default TransaksiPosService;
